<style scoped lang="scss">
.wrap {
  width: 100%;
  display: flex;
  margin-top: 42px;
  align-items: stretch;
}

.left {
  width: 411px;
  height: 325px;
  border: 1px solid #dcdfe6;
}

.item1 {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
  height: 60px;
  margin-top: -50px;

  .icon {
    display: inline-block;
    width: 5px;
    height: 16px;
    background: #419fff;
  }

  .txt {
    display: inline-block;
    font-weight: 400;
    font-size: 16px;
    color: #303133;
    margin-left: 12px;
  }
}

.item2 {
  width: 100%;
  height: 270px;

  //border: 1px solid #DCDFE6;
  .header {
    width: 411px;
    padding: 20px 15px 6px 15px;

    .title {
      font-size: 16px;
      line-height: 22px;
      font-weight: 700;
      color: #303133;
    }

    .circle {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #e6a23c;
      margin: 0 9px 0 13px;
    }

    .tag-left {
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #606266;
    }

    .tag-right {
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #606266;
    }
  }

  .reason {
    width: 100%;
    height: 270px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-top: 15px;
    overflow: auto;
    margin-bottom: 10px;

    .reason__item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;
      margin-left: 15px;

      .content {
        //display: flex;
        //align-items: center;
        display: grid;
        grid-template-columns: 20px 150px 200px 120px;
        width: 100%;

        .sort {
          height: 17px;
          width: 17px;
          border-radius: 50%;
          color: white;
          background-color: #909399;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .title {
          font-size: 12px;
          line-height: 22px;
          color: #303133;
          margin-left: 10px;
          width: 150px;
        }

        //.label {
        //  color: #606266;
        //  margin-left: 8px;
        //  width: 120px;
        //  overflow: hidden;
        //}

        .chart {
          height: 8px;
          background-color: #419fff;
          margin-left: 8px;
          width: 200px;
          margin-top: 6px;
        }

        .label {
          font-size: 12px;
          line-height: 18px;
          color: #e6a23c;
          width: 120px;
          margin-left: 20px;
        }

        .label-l,
        .label-r {
          margin-left: 5px;
        }

        .label-r {
          color: #f56c6c;
        }
      }
    }
  }
}

.right {
  flex: 1;
  height: 325px;
  margin-left: 18px;
  border: 1px solid #dcdfe6;
  padding: 20px 28px 46px 28px;
  display: flex;

  .item2 {
    width: 100%;
    height: 300px;

    .header {
      color: #303133;
      font-size: 16px;
      margin-top: -10px;
    }

    #tableChart {
      width: 100%;
      height: 310px;
    }
  }
}
</style>

<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/custom/lingpao/productWeighingiInfo/page" ref="yt" getKey="rows" :columns="columns" @afterGet="afterGet" @selectionChange="selectionChange">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input :format="'yyyy-MM-dd HH:mm:ss'" :maxTime="31 * 24 * 3600 * 1000" type="datetimerange" ref="yiTime" :start.sync="yt.conditions.begin" :end.sync="yt.conditions.end"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('chanpinsn')">
            <el-input v-model="yt.conditions.productSn" size="mini" />
          </el-form-item>
          <el-form-item :label="$t('shengchanongdanhao')">
            <el-input v-model="yt.conditions.sourceWoNo" size="mini" />
          </el-form-item>
          <el-button @click="queryData()" type="primary" plain size="mini">
            {{ $t('sousuo') }}
          </el-button>
          <el-button @click="clear()" size="mini">{{ $t('chongzhi') }}</el-button>
        </el-form>
      </template>

      <template #buttonsR>
        <el-button :loading="weight_info_export_loading" size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
    </yi_curd_table>
  </div>
</template>

<script>
import XLSX from 'xlsx';
const date = new Date();
const end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59).getTime();
const begin = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime();
export default {
  name: 'lingpao_report_product_weight_index',
  data() {
    return {
      list: [],
      conditions: {
        begin: begin,
        end: end
      },
      columns: [
        {
          label: 'chanpinsn',
          prop: 'productSn'
        },
        {
          label: 'shengchanongdanhao',
          prop: 'wo.no'
        },
        {
          label: 'shebeiSN',
          prop: 'equipment.sn'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'chengzhongshijian',
          prop: 'weighingTime',
          type: 'time'
        },

        {
          label: 'chengzhongshebei',
          prop: 'weighDevice'
        },
        {
          label: 'chengzhngjieguo',
          prop: 'weighResult'
        },
        {
          label: 'chengzhongshijizhongliang',
          prop: 'actualWeigh'
        },
        {
          label: 'chengzhongbiaozhunshangxian',
          prop: 'upperLimit'
        },
        {
          label: 'chengzhongbiaozhunxiaxian',
          prop: 'lowerLimit'
        },
        {
          label: 'shifoubuliang',
          prop: 'badFlag',
          type: 'bool'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        }
      ]
    };
  },
  methods: {
    queryData() {
      if (this.conditions.begin == null || this.conditions.end == null) {
        this.$message.error(this.$t('report_time_not_null'));
        return;
      }
      this.yt.get(1);
    },
    clear() {
      (this.conditions.begin = begin), (this.conditions.end = end), (this.conditions.productSn = null), (this.conditions.sourceWoNo = null), (this.yt.conditions = this.conditions);
      this.yt.get(1);
    },

    exportExcel() {
      this.weight_info_export_loading = true;
      //查询表格
      this.http
        .get('/custom/lingpao/productWeighingiInfo/page?page=1&limit=10000', { params: { ...this.conditions } })
        .then(res => {
          let tableFirst = this.columns.map(i => this.$t(i.label));
          let tableData = [];
          tableData.push(tableFirst);
          let listData = res.data.rows;
          for (let i = 0; i < listData.length; i++) {
            let dataArr = this.getTableDataArr(listData[i]);
            tableData.push(dataArr);
          }
          console.log('tableArr', tableData);
          const worksheet = XLSX.utils.aoa_to_sheet(tableData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          XLSX.writeFile(workbook, `产品称重信息_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
        })
        .finally(() => {
          this.weight_info_export_loading = false;
        });
    },
    getTableDataArr(row) {
      let dataArr = [];
      dataArr[0] = row.productSn;
      dataArr[1] = row.wo.no;
      dataArr[2] = row.equipment.sn;
      dataArr[3] = row.equipment.name;
      dataArr[4] = row.weighingTime && this.dayjs(row.weighingTime).format('YYYY-MM-DD HH:mm:ss');
      dataArr[5] = row.weighDevice;
      dataArr[6] = row.weighResult;
      dataArr[7] = row.actualWeigh;
      dataArr[8] = row.upperLimit;
      dataArr[9] = row.lowerLimit;
      dataArr[10] = row.createTime && this.dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss');
      return dataArr;
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = this.conditions;
      this.yt.get(1);
      this.$nextTick(() => {
        this.utils.event_hub.$emit('RESIZE');
      });
    }, 300);
  }
};
</script>
